import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FormlyFillHeightListHostDirective } from '../../../custom-formly/formly-tabs/formly-fill-height-list-host.directive';
import { ProductAddressLinkListEditWidgetComponent } from '../product-address-link-list-edit-widget/product-address-link-list-edit-widget.component';

@Component({
  selector: 'app-formly-product-address-link-edit',
  templateUrl: './formly-product-address-link-edit.component.html',
  hostDirectives: [FormlyFillHeightListHostDirective],
  standalone: true,
  imports: [
    ProductAddressLinkListEditWidgetComponent,
    TranslatePipe,
    CommonModule,
  ]
})
export class FormlyProductAddressLinkEditComponent extends FieldType {

  @Input()
  productId: string;

  constructor(
    private cdRef: ChangeDetectorRef,
  ) {
    super();
  }


  ngOnInit(): void {

    this.getProductId();
    this.formControl?.valueChanges.subscribe(x => {
      this.getProductId();
    });
  }

  getProductId() {
    this.productId = this.model[this.key as string];
  }

}
